export default {"src":"/_next/static/media/beta-mobile-inverted.57b64291.svg","height":100,"width":174,"blurWidth":0,"blurHeight":0};